import React from 'react';
//import css from './css.module.less';
import BlockTitle from '@/src/components/Modules-revamp/BlockTitle';
import FocusPoint from 'src/components/ImageFocusPointEdit';
import {
  Item as ItemWrapper,
  SectionContainer as Section,
} from 'src/components/Layouts';
import Wrapper from 'src/components/Modules-revamp/BlockWrapper';
import Uploader from 'src/constrains/SingleImageUploader';
import {
  TopLeaderBoardBanner,
  imageSetting,
  link,
  linkImage,
  topLeaderBoardBanner,
} from 'src/pages/SalesChannelContentEditor/SalesChannelEditorAppearanc-revamp/constant';
import { sectionProps } from 'src/tools/constant';
// import { useSalesChannelGeneralLinkSet } from 'src/components/LinkModule/hooks';
import LinkLibrary from '@/src/constrains/LinkLibrary';
import { editable } from '@/src/tools/contentModulesFieldName';
import { LinkModuleType } from '@/src/types/common/linkType';
import { get, set } from 'lodash';
import { useParams } from 'react-router-dom';
import { Field, itemWrapperErrorDisplayAdaptor } from 'src/components/RcForm';
import { useI18n } from 'src/hooks/useRouterChange';
import { checkTopLeaderBoardBanner } from 'src/pages/SalesChannelContentEditor/SalesChannelEditorAppearanc-revamp/validator';
import { i18nGet } from 'src/tools/tools';
import { topLeadBoardBannerFields } from '../fields';
import { getEditableStatus } from '../util';
const { checkImg, checkLink, checkAll } = checkTopLeaderBoardBanner();
const linkN = [topLeaderBoardBanner, link];
const imageN = [...linkN, linkImage];
const focusN = [...imageN, imageSetting];

const Top = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { breakpoint, disabled } = props;
  const _params: any = useParams();
  const { contentUuid } = _params;
  const linkSet = {
    scopeVariables: { SalesChannelContent: contentUuid },
    linkTypeFilter: [
      LinkModuleType.Product,
      LinkModuleType.Collection,
      LinkModuleType.ContentPage,
      LinkModuleType.LinkLibrary,
      LinkModuleType.None,
      LinkModuleType.SysModule,
    ],
  };
  return (
    <Wrapper id={TopLeaderBoardBanner} breakpoint={breakpoint}>
      <BlockTitle
        id={TopLeaderBoardBanner}
        title={getI18n('general.hOCTitle.topLeaderBoardBanner')}
        breakpoint={breakpoint}
        onReset={() =>
          props.handleOnSectionReset(topLeadBoardBannerFields, breakpoint)
        }
        onCopy={() =>
          props.handleOnSectionCopy(topLeadBoardBannerFields, breakpoint)
        }
        headerErrorDependencies={[linkN]}
        validator={(data) => {
          const top = get(data, topLeaderBoardBanner);
          return checkAll(top);
        }}
      />
      <Section {...sectionProps}>
        <Field
          shouldUpdate={(p, c) => {
            return (
              get(p, `${TopLeaderBoardBanner}_${editable}`) !==
              get(c, `${TopLeaderBoardBanner}_${editable}`)
            );
          }}>
          {(props, meta, { getFieldsValue }) => {
            return (
              <Field
                name={imageN}
                rules={[
                  {
                    validator: async (rules: any, value: any) => {
                      const res = checkImg(value);

                      const hasError = get(res, 'hasError');
                      const errors = get(res, 'errors');
                      if (hasError) {
                        return Promise.reject(
                          new Error((errors || []).join(',')),
                        );
                        //</ItemWrapper>throw Error((errors || []).join(','));
                      }
                    },
                  },
                ]}>
                {(
                  props,
                  meta,
                  { getFieldValue, setFields, setFieldsValue },
                ) => {
                  const e = itemWrapperErrorDisplayAdaptor(meta);
                  const is_editable = getEditableStatus(
                    getFieldValue,
                    TopLeaderBoardBanner,
                    breakpoint,
                  );
                  console.log('edit', breakpoint, is_editable, disabled);
                  return (
                    <ItemWrapper
                      title={`${getI18n('general.tools_helper.image')}*`}
                      bottomTitle={`${getI18n(
                        'general.allowedfiletypes',
                      )}: jpeg, gif, png`}
                      size='small'
                      {...e}>
                      <Uploader
                        height={180}
                        {...props}
                        disabled={disabled || !is_editable}
                      />
                    </ItemWrapper>
                  );
                }}
              </Field>
            );
          }}
        </Field>

        <Field
          shouldUpdate={(p, c) => {
            return (
              get(p, imageN) !== get(c, imageN) ||
              get(p, `${TopLeaderBoardBanner}_${editable}`) !==
                get(c, `${TopLeaderBoardBanner}_${editable}`)
            );
          }}>
          {(props, meta, { getFieldValue, setFields, setFieldsValue }) => {
            const image = getFieldValue(imageN);
            const is_editable = getEditableStatus(
              getFieldValue,
              TopLeaderBoardBanner,
              breakpoint,
            );
            return (
              <Field name={focusN}>
                {(props, meta) => {
                  //const value = props.value;
                  const onChange = props.onChange;
                  return (
                    <FocusPoint
                      image={image}
                      disable={disabled || !is_editable}
                      onChange={(image) => {
                        onChange(get(image, 'image.imageSetting'));
                      }}
                    />
                  );
                }}
              </Field>
            );
          }}
        </Field>
        {!disabled && (
          <Field
            initialValue={{
              linkType: 'None',
              label: getI18n('general.status.none'),
            }}
            name={linkN}
            //  dependencies={[`${TopLeaderBoardBanner}_${editable}`]}
            rules={[
              {
                validator: async (rules: any, value: any) => {
                  const res = checkLink(value);

                  const hasError = get(res, 'hasError');
                  const errors = get(res, 'errors');
                  if (hasError) {
                    return Promise.reject(new Error((errors || []).join(',')));
                    //</ItemWrapper>throw Error((errors || []).join(','));
                  }
                },
              },
            ]}>
            {(props, meta, { getFieldValue }) => {
              const value = props.value;
              const image = getFieldValue(imageN);
              const onChange = (v, ...args) => {
                set(v, linkImage, image);
                props.onChange(v, ...args);
              };
              const is_editable = getEditableStatus(
                getFieldValue,
                TopLeaderBoardBanner,
                breakpoint,
              );
              const errors = get(meta, 'errors');
              return (
                <LinkLibrary
                  disabled={disabled || !is_editable}
                  error={(errors || []).join(' ')}
                  data={value}
                  onChange={onChange}
                  linkSet={linkSet}
                />
              );
            }}
          </Field>
        )}
      </Section>
    </Wrapper>
  );
};
export default Top;
